import tw, { styled } from 'twin.macro'
import type { TTextAreaProps } from './interface'

export const StyledLabel = styled.label(() => [tw`text-gray-3 px-6`])

const TextAreaBase = tw`w-full min-h-32 rounded-2xl px-6 h-12 border-2 border-solid transition duration-300 ease-in-out`
const TextAreaStyle = tw`text-gray-2 placeholder:text-gray-2 focus-visible:text-black focus-visible:placeholder:text-black focus-visible:border-black`
const TextAreaErrorStyle = tw`border-red-500`

export const getTextAreaStyle = (isError: TTextAreaProps['isError']) => (isError ? TextAreaErrorStyle : TextAreaStyle)

export const StyledTextArea = styled.textarea(({ isError }: TTextAreaProps) => [
  TextAreaBase,
  tw`px-6 py-4`,
  getTextAreaStyle(isError),
])
